module.exports = "<iframe src=\"swagger-ui/index.html\" width=\"100%\" height=\"900\" seamless\n    target=\"_top\" title=\"Swagger UI\" class=\"border-0\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/admin/docs/docs.component.html
// module id = 414
// module chunks = 0